import { Component, EventEmitter, inject, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/services/auth/auth.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent {
    private router = inject(Router);
    private auth = inject(AuthService);
    @Output() toggleSidebar = new EventEmitter<void>();

    onLogout(): void {
        this.auth.logout(); 
        this.router.navigateByUrl('/auth', { replaceUrl: true }); 
    }
}
